import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

type FlowStatus = 'blocked' | 'in progress' | 'completed';

@Component({
    selector: 'flow-progress',
    templateUrl: './flow-progress.component.html',
    styleUrls: ['./flow-progress.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FlowProgressComponent  {
    @Input() experienceStatus: FlowStatus = 'blocked';
    @Input() reflectionStatus: FlowStatus = 'blocked';
    @Input() learningStatus: FlowStatus = 'blocked';
    @Input() resultsStatus: FlowStatus = 'blocked';

    @Output() onExperienceClick = new EventEmitter();
    @Output() onReflectionClick = new EventEmitter();
    @Output() onLearningClick = new EventEmitter();
    @Output() onResultsClick = new EventEmitter();

    experienceClicked() {
    	this.onExperienceClick.emit();
    }

    reflectionClicked() {
    	this.onReflectionClick.emit();
    }

    learningClicked() {
    	this.onLearningClick.emit();
    }

    resultsClicked() {
    	this.onResultsClick.emit();
    }
}
